<template>
  <div class="wrapper">
    <el-card class="box-card" v-for="(card,index) in update.col.data">
      <div slot="header" class="clearfix">
        <div>{{$t('crs.active.task')}}{{index+1}}</div>
        <div style="float: right" v-if="!readonly">
          <el-button type="text" @click="addReward()">{{$t('crs.bt.add')}}</el-button>
          <el-button v-if="update.col.data.length > 1" type="text" @click="delReward(index)">{{$t('crs.bt.delete')}}</el-button>
        </div>
      </div>
      <div class="text item">
        <el-form-item :label="$t('crs.active.task')" :required="true">
          <el-select  v-model="card.task" :placeholder="$t('crs.active.selectTask')" :disabled="readonly">
            <el-option v-for="(task,index) in taskList" :label="task.name" :value="task.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('crs.active.taskTitle')" :required="true">
          <el-input v-model="card.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crs.active.taskDescribe')" :required="true">
          <el-input v-model="card.describe"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crs.active.rewardValue')" :required="true">
          <el-input v-model="card.rewardValue" :readonly="readonly"></el-input>
        </el-form-item>
      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: 'task',
    props:["update"],
    methods: {
        addReward(){
            this.update.col.data.push({rewardType:1});
        },
        delReward(index){
            this.update.col.data.splice(index, 1);
        }
    },
    computed:{
        readonly(){
            return (this.update.updateModel.id && this.update.updateModel.status != -1)?true:false;
        }
    },
    data () {
      return {
          taskList: [
              { name: window.$t('crs.active.task1'), value: "1" },
              { name: window.$t('crs.active.task3'), value: "3" },
              { name: window.$t('crs.active.task4'), value: "4" },
              { name: window.$t('crs.active.task5'), value: "5" },
              { name: window.$t('crs.active.task6'), value: "6" },
              { name: window.$t('crs.active.task7'), value: "7" },
              { name: window.$t('crs.active.task8'), value: "8" },
              { name: window.$t('crs.active.task9'), value: "9" },
              { name: window.$t('crs.active.task10'), value: "10" }
          ],
      }
    }
  }
</script>
